import { getApiUrl } from '@/utils/auth/authService';

// nav.js logoutToken(): a plain POST invalidating one token - logout() calls this once per token
// type the user holds (token/tokenSales/tokenDoc/tokenAssort), each with its own explicit value,
// so this takes the token itself rather than a context-derived tokenType like authenticatedFetch().
export async function logoutToken(token) {
	if (!token) return;
	await fetch(getApiUrl('Auth/Logout'), { method: 'POST', headers: { Token: token }, body: `foo=${Date.now()}` }).catch(() => {});
}
